export default "__VITE_ASSET__BcVqkSNs__"